import { FC, useMemo } from 'react';
import { HTHMarkerBuilding } from 'src/components/_commons/house-to-house';
import { typeHTHBuilding, typeHTHFace } from '@monorepo/models';

type propsType = {
    polygon: typeHTHFace;
};

export const HTHInteractiveMapMapBuildings: FC<propsType> = ({ polygon }) => {

    return (
        <>
        {polygon.buildings.filter(b => b.coords && b.households.some(h => h.history.filter(h => !!h.state).length)).map(b =>
            <Polygon  key={`${polygon.id}_${b.streetNumber}`}
                building={b}
            />
        )}
        </>
    );
}

const Polygon = ({ building }: { building: typeHTHBuilding; }) => {
    const color: string = useMemo(() => {
        const dates = building.households.flatMap(h => h.history.filter(h => !!h.state).map(h => h.timestamp));
        dates.sort((d1, d2) => d2 - d1);
        if (dates.length) {
            const datetime = dates[0];
            const date = new Date(datetime);
            date.setHours(date.getHours() - 3);
            const lastTimeMonth = new Date(date.getFullYear(), date.getMonth()).getTime();
            const month = new Date().getMonth();
            const year = new Date().getFullYear();
            const currentMonth = new Date(year, month).getTime();
            const pastMonth = new Date(year, month - 1).getTime();
            const pastPastMonth = new Date(year, month - 2).getTime();
            const pastPastPastMonth = new Date(year, month - 3).getTime();
            const pastPastPastPastMonth = new Date(year, month - 4).getTime();
            switch (lastTimeMonth) {
                case currentMonth:
                    return 'green';
                case pastMonth:
                    return 'yellow';
                case pastPastMonth:
                    return 'orange';
                case pastPastPastMonth:
                    return 'pink';
                case pastPastPastPastMonth:
                    return 'red';
            }
        }
        return '';
    }, [building]);
    
    if (!color) {
        return <></>;
    }
    
    return (
        <HTHMarkerBuilding
            building={building}
            color={color}
        />
    );
}
